import React from "react";
import clsx from "clsx";
import styles from "./style/FeatureCard.module.css";
import PropTypes from "prop-types";

const FeatureCard = ({ icon, title, subtitle, className }) => {
  return (
    <div className={clsx(className)}>
      <div
        className={clsx(
          "d-flex flex-column align-items-center justify-content-center bg-white border rounded mb-4 p-4"
        )}
      >
        <div className={clsx(styles.featureIcon, " px-3 py-2 rounded")}>
          {icon}
        </div>
        <h5 className={clsx("m-3")}>{title}</h5>
        <p>{subtitle}</p>
      </div>
    </div>
  );
};

/* required: display name */
FeatureCard.displayName = "FeatureCard";

/* required: props types */
FeatureCard.propTypes = {
  icon: PropTypes.any,
  title: PropTypes.any,
  subtitle: PropTypes.any,
  className: PropTypes.any,
};

/* required: default props */
FeatureCard.defaultProps = {
  icon: null,
  title: null,
  subtitle: null,
  className: null,
};

export { FeatureCard };
